<div class="flex-auto flex-wrap justify-content-center">
  <form id="dynamic-form" [formGroup]="dynamicForm" (ngSubmit)="onSubmit()">
    @if (formTemplateList.length) {
      <ng-container
        *ngTemplateOutlet="
          dynamicFormTemplateList;
          context: {templateList: formTemplateList, parentGroup: dynamicForm}
        "></ng-container>
    } @else {
      <p-message icon="pi pi-info-circle" styleClass="justify-content-start align-items-center" severity="info">
        <div innerHTML="{{ 'ClinicalHistory.Common.NoTemplate' | translate }}"></div>
      </p-message>
    }
  </form>
</div>

<ng-template
  #dynamicFormTemplateList
  let-templateList="templateList"
  let-parentGroup="parentGroup"
  let-tabIndex="tabIndex">
  <ng-container [formGroup]="parentGroup">
    @for (formTemplate of templateList; track formTemplate) {
      @switch (formTemplate.type) {
        @case (eDynamicFormType.HtmlTag) {
          @if (!isHidden(formTemplate, parentGroup)) {
            <div class="flex mb-2" [class.flex-column]="formTemplate.labelTop">
              <div class="align-content-center my-2 col-12">
                @if (formTemplate.name?.split('.'); as tags) {
                  @switch (tags[tags.length - 1]) {
                    @case ('h5') {
                      <h5>{{ formTemplate.label }}</h5>
                    }
                    @case ('p') {
                      <p [innerHTML]="formTemplate.label"></p>
                    }
                    @case ('hr') {
                      <p-divider styleClass="p-divider-gray"></p-divider>
                    }
                  }
                }
              </div>
            </div>
          }
        }

        @case (eDynamicFormType.InputGroup) {
          @if (dynamicFormUtils.castAsInputGroup(formTemplate); as formTemplateItem) {
            @if (!isHidden(formTemplateItem, parentGroup)) {
              <div
                class="flex mb-2"
                [class.flex-column]="formTemplateItem.labelTop"
                [formGroupName]="formTemplateItem.name">
                <div class="align-content-center my-2" [class]="getLabelColClass(formTemplateItem)">
                  <label
                    class="label"
                    [class.asterisk]="isRequired(formTemplateItem, parentGroup, tabIndex)"
                    [for]="formTemplateItem.name + (tabIndex ?? '')">
                    {{ formTemplateItem.label }}
                  </label>
                </div>
                <div class="align-items-center flex justify-content-end" [class]="getFieldColClass(formTemplateItem)">
                  <div class="p-inputgroup">
                    @for (field of formTemplateItem.fields; track field) {
                      <ng-container
                        *ngTemplateOutlet="
                          dynamicField;
                          context: {
                            formTemplate: field,
                            parentGroup: parentGroup.get(formTemplateItem.name),
                            tabIndex: tabIndex,
                          }
                        "></ng-container>
                    }
                  </div>
                  @for (field of formTemplateItem.fields; track field) {
                    <ng-container
                      *ngTemplateOutlet="
                        dynamicFieldValidations;
                        context: {
                          formTemplate: field,
                          parentGroup: parentGroup.get(formTemplateItem.name),
                          tabIndex: tabIndex,
                        }
                      "></ng-container>
                  }
                </div>
              </div>
            }
          }
        }

        @case (eDynamicFormType.Accordion) {
          @if (dynamicFormUtils.castAsAccordion(formTemplate); as formTemplateItem) {
            @if (!isHidden(formTemplateItem, parentGroup)) {
              <div class="flex mb-2" [class.flex-column]="formTemplateItem.labelTop">
                <div [formArrayName]="formTemplateItem.name" class="align-content-center my-2 col-12">
                  <p-accordion
                    [id]="formTemplateItem.name"
                    [multiple]="true"
                    [value]="accordionExpandValue[formTemplateItem.name]">
                    @for (accordionField of formTemplateItem.fields; track accordionField; let i = $index) {
                      @if (
                        accordionField.type === eDynamicFormType.AccordionTab &&
                          dynamicFormUtils.castAsAccordionTab(accordionField);
                        as accordionFieldItem
                      ) {
                        <p-accordion-panel
                          [id]="accordionFieldItem.name + i"
                          [formGroupName]="i"
                          [value]="i"
                          iconPos="end"
                          [disabled]="isDisabled(accordionFieldItem, parentGroup)">
                          <p-accordion-header class="bg-transparent uppercase">{{
                            accordionFieldItem.label
                          }}</p-accordion-header>
                          <p-accordion-content>
                            <ng-container
                              *ngTemplateOutlet="
                                dynamicFormTemplateList;
                                context: {
                                  templateList: accordionFieldItem.fields,
                                  parentGroup: parentGroup.controls[formTemplateItem.name].controls[i],
                                  tabIndex: tabIndex,
                                }
                              "></ng-container>
                          </p-accordion-content>
                        </p-accordion-panel>
                      }
                    }
                  </p-accordion>
                </div>
              </div>
            }
          }
        }

        @case (eDynamicFormType.VariableAccordion) {
          @if (dynamicFormUtils.castAsVariableAccordion(formTemplate); as formTemplateItem) {
            @if (!isHidden(formTemplateItem, parentGroup)) {
              <div class="flex mb-2" [class.flex-column]="formTemplateItem.labelTop">
                <div class="align-content-center my-2 col-12">
                  <p-accordion
                    [id]="formTemplateItem.name"
                    [formArrayName]="formTemplateItem.name"
                    [multiple]="true"
                    [value]="variableAccordionExpandValue[formTemplateItem.name]">
                    @for (accordionField of formTemplateItem.fields; track accordionField; let i = $index) {
                      @if (
                        accordionField.type === eDynamicFormType.VariableAccordionTab &&
                          dynamicFormUtils.castAsVariableAccordionTab(accordionField);
                        as accordionFieldItem
                      ) {
                        <p-accordion-panel
                          [id]="accordionFieldItem.name + i"
                          [formGroupName]="i"
                          [value]="i"
                          iconPos="end"
                          [disabled]="isDisabled(accordionFieldItem, parentGroup)">
                          <p-accordion-header class="bg-transparent uppercase">
                            {{ accordionFieldItem.label }}&nbsp;{{ i + 1 }}
                          </p-accordion-header>
                          <p-accordion-content>
                            <ng-container
                              *ngTemplateOutlet="
                                dynamicFormTemplateList;
                                context: {
                                  templateList: accordionFieldItem.fields,
                                  parentGroup: parentGroup.controls[formTemplateItem.name].controls[i],
                                  tabIndex: i,
                                }
                              "></ng-container>
                            @if (formTemplateItem.min && i >= formTemplateItem.min) {
                              <p-button
                                label="{{ 'DynamicForm.VariableAccordionRemove' | translate }} {{ i + 1 }}"
                                styleClass="p-button-outlined p-button-rounded"
                                class="p-2"
                                (onClick)="removeVariableAccordionTab(formTemplateItem, i)"></p-button>
                            }
                            <p-divider styleClass="p-divider-gray"></p-divider>
                          </p-accordion-content>
                        </p-accordion-panel>
                      }
                    }
                    <ng-container>
                      <h5>
                        {{ 'DynamicForm.VariableAccordionAddTitle' | translate }}
                      </h5>
                      <p-button
                        label="{{ 'DynamicForm.VariableAccordionAdd' | translate }}"
                        icon="pi pi-plus-circle"
                        styleClass="p-button-rounded"
                        class="p-2"
                        [disabled]="formTemplateItem.max === formTemplateItem.fields.length"
                        (onClick)="addVariableAccordionTab(formTemplateItem)"></p-button>
                    </ng-container>
                  </p-accordion>
                </div>
              </div>
            }
          }
        }

        @default {
          @if (!isHidden(formTemplate, parentGroup)) {
            <div
              class="flex mb-2 {{ isHidden(formTemplate, parentGroup) }}"
              [class.flex-column]="formTemplate.labelTop">
              <div class="align-content-center my-2" [class]="getLabelColClass(formTemplate)">
                @if (
                  !(
                    formTemplate.type === eDynamicFormType.Checkbox ||
                    formTemplate.type === eDynamicFormType.RadioButton
                  )
                ) {
                  <label
                    class="label"
                    [class.asterisk]="isRequired(formTemplate, parentGroup, tabIndex)"
                    [for]="formTemplate.name + (tabIndex ?? '')">
                    {{ formTemplate.label }}
                  </label>
                }
                @if (
                  formTemplate.type === eDynamicFormType.Checkbox || formTemplate.type === eDynamicFormType.RadioButton
                ) {
                  <span class="label" [class.asterisk]="isRequired(formTemplate, parentGroup)">
                    {{ formTemplate.label }}
                  </span>
                }
              </div>
              <div class="align-items-center flex justify-content-end" [class]="getFieldColClass(formTemplate)">
                <div
                  [class.w-full]="
                    !(
                      formTemplate.type === eDynamicFormType.Checkbox ||
                      formTemplate.type === eDynamicFormType.RadioButton
                    )
                  ">
                  <ng-container
                    *ngTemplateOutlet="
                      dynamicField;
                      context: {
                        formTemplate: formTemplate,
                        parentGroup: parentGroup,
                        tabIndex: tabIndex,
                      }
                    "></ng-container>
                </div>
                <ng-container
                  *ngTemplateOutlet="
                    dynamicFieldValidations;
                    context: {
                      formTemplate: formTemplate,
                      parentGroup: parentGroup,
                      tabIndex: tabIndex,
                    }
                  "></ng-container>
              </div>
            </div>
          }
        }
      }
    }
  </ng-container>
</ng-template>

<ng-template #dynamicField let-formTemplate="formTemplate" let-parentGroup="parentGroup" let-tabIndex="tabIndex">
  <ng-container [formGroup]="parentGroup">
    @switch (formTemplate.type) {
      @case (eDynamicFormType.InputGroupAddon) {
        <span class="p-inputgroupaddon">{{ formTemplate.label }}</span>
      }

      @case (eDynamicFormType.InputText) {
        @if (dynamicFormUtils.castAsInputText(formTemplate); as formTemplateItem) {
          <input
            pInputText
            type="text"
            [id]="formTemplateItem.name + (tabIndex ?? '')"
            [formControlName]="formTemplateItem.name"
            [placeholder]="formTemplateItem.placeholder"
            class="w-full"
            [required]="isRequired(formTemplateItem, parentGroup, tabIndex)"
            [disabled]="isDisabled(formTemplateItem, parentGroup)" />
        }
      }

      @case (eDynamicFormType.InputNumber) {
        @if (dynamicFormUtils.castAsInputNumber(formTemplate); as formTemplateItem) {
          <p-inputNumber
            [id]="formTemplateItem.name + (tabIndex ?? '')"
            [formControlName]="formTemplateItem.name"
            [placeholder]="formTemplateItem.placeholder"
            styleClass="w-full"
            class="w-full"
            [required]="isRequired(formTemplateItem, parentGroup, tabIndex)"
            [disabled]="isDisabled(formTemplateItem, parentGroup)">
          </p-inputNumber>
        }
      }

      @case (eDynamicFormType.Textarea) {
        @if (dynamicFormUtils.castAsTextarea(formTemplate); as formTemplateItem) {
          <textarea
            pInputTextarea
            [rows]="formTemplateItem.rows"
            [cols]="formTemplateItem.cols"
            autoResize="true"
            [id]="formTemplateItem.name + (tabIndex ?? '')"
            [formControlName]="formTemplateItem.name"
            [placeholder]="formTemplateItem.placeholder"
            class="p-inputtextarea w-full"
            [required]="isRequired(formTemplateItem, parentGroup, tabIndex)"
            [disabled]="isDisabled(formTemplateItem, parentGroup)"></textarea>
        }
      }

      @case (eDynamicFormType.Date) {
        @if (dynamicFormUtils.castAsDate(formTemplate); as formTemplateItem) {
          <app-masked-calendar
            [id]="formTemplateItem.name + (tabIndex ?? '')"
            [formControlName]="formTemplateItem.name"
            class="w-full"
            styleClass="w-full"
            [required]="isRequired(formTemplateItem, parentGroup, tabIndex)"
            [disabled]="isDisabled(formTemplateItem, parentGroup)"></app-masked-calendar>
        }
      }

      @case (eDynamicFormType.Select) {
        @if (dynamicFormUtils.castAsSelect(formTemplate); as formTemplateItem) {
          @if (selectState$ | async; as selectState) {
            <p-select
              styleClass="w-full"
              class="w-full"
              [id]="formTemplateItem.name + (tabIndex ?? '')"
              [formControlName]="formTemplateItem.name"
              [dataKey]="formTemplateItem.optionValue"
              [virtualScroll]="false"
              [virtualScrollItemSize]="50"
              [loading]="isSingleOrMultiSelectLoading(formTemplateItem, selectState)"
              [options]="loadSingleOrMultiSelectOptions(formTemplateItem, selectState)"
              [optionLabel]="formTemplateItem.showValueInLabel ? 'displayLabel' : formTemplateItem.optionLabel"
              [filter]="true"
              [filterBy]="formTemplateItem.filterBy"
              [filterPlaceholder]="formTemplateItem.filterPlaceHolder"
              [filterValue]="formTemplateItem.filterValue"
              [resetFilterOnHide]="true"
              [lazy]="formTemplateItem.lazy ?? false"
              (onClick)="onSingleOrMultiSelectClick($event, formTemplateItem)"
              (onFilter)="onSingleOrMultiSelectFilter($event, formTemplateItem)"
              [placeholder]="getSingleOrMultiSelectPlaceholder(formTemplateItem, selectState)"
              [required]="isRequired(formTemplateItem, parentGroup, tabIndex)"
              [disabled]="isDisabled(formTemplateItem, parentGroup)"></p-select>
          }
        }
      }

      @case (eDynamicFormType.MultiSelect) {
        @if (dynamicFormUtils.castAsMultiSelect(formTemplate); as formTemplateItem) {
          @if (multiSelectState$ | async; as multiSelectState) {
            <p-multiSelect
              styleClass="w-full"
              class="w-full"
              [id]="formTemplateItem.name + (tabIndex ?? '')"
              [formControlName]="formTemplateItem.name"
              [dataKey]="formTemplateItem.optionValue"
              [virtualScroll]="true"
              [virtualScrollItemSize]="50"
              [loading]="isSingleOrMultiSelectLoading(formTemplateItem, multiSelectState)"
              [options]="loadSingleOrMultiSelectOptions(formTemplateItem, multiSelectState)"
              [maxSelectedLabels]="formTemplateItem.options?.length"
              [optionLabel]="formTemplateItem.showValueInLabel ? 'displayLabel' : formTemplateItem.optionLabel"
              [display]="formTemplateItem.display ?? 'comma'"
              [showToggleAll]="formTemplateItem.showToggleAll ?? false"
              [filter]="true"
              [filterBy]="formTemplateItem.filterBy"
              [filterPlaceHolder]="formTemplateItem.filterPlaceHolder"
              [filterValue]="formTemplateItem.filterValue"
              [resetFilterOnHide]="true"
              [lazy]="formTemplateItem.lazy ?? false"
              (onClick)="onSingleOrMultiSelectClick($event, formTemplateItem)"
              (onFilter)="onSingleOrMultiSelectFilter($event, formTemplateItem)"
              [placeholder]="getSingleOrMultiSelectPlaceholder(formTemplateItem, multiSelectState)"
              [required]="isRequired(formTemplateItem, parentGroup, tabIndex)"
              [disabled]="isDisabled(formTemplateItem, parentGroup)">
            </p-multiSelect>
          }
        }
      }

      @case (eDynamicFormType.RadioButton) {
        @if (dynamicFormUtils.castAsRadioButton(formTemplate); as formTemplateItem) {
          @for (option of formTemplateItem.options; track option) {
            <div class="field-radiobutton" [class.inline-flex]="formTemplateItem.direction === eDirection.Horizontal">
              <p-radioButton
                inputId="{{ formTemplateItem.name + (tabIndex ?? '') + '_' + option.value }}"
                [value]="option.value"
                name="{{ formTemplateItem.name + (tabIndex ?? '') }}"
                [formControl]="parentGroup.get(formTemplateItem.name)"
                styleClass="w-full"
                [required]="isRequired(formTemplateItem, parentGroup, tabIndex)"
                [disabled]="isDisabled(formTemplateItem, parentGroup)"></p-radioButton>
              <label
                for="{{ formTemplateItem.name + (tabIndex ?? '') + '_' + option.value }}"
                class="mx-2 cursor-pointer">
                {{ option.label }}
              </label>
            </div>
          }
        }
      }

      @case (eDynamicFormType.Checkbox) {
        @if (dynamicFormUtils.castAsCheckbox(formTemplate); as formTemplateItem) {
          @for (option of formTemplateItem.options; track option) {
            <div class="field-checkbox" [class.inline-flex]="formTemplateItem.direction === eDirection.Horizontal">
              <p-checkbox
                inputId="{{ formTemplateItem.name + (tabIndex ?? '') + '_' + option.value }}"
                [value]="option.value"
                name="{{ formTemplateItem.name + (tabIndex ?? '') }}"
                formControlName="{{ formTemplateItem.name + (tabIndex ?? '') + '_' + option.value }}"
                [ariaChecked]="formTemplateItem.name"
                [disabled]="isDisabled(formTemplateItem, parentGroup)"
                (ngModelChange)="onCheckboxChecked(parentGroup, formTemplateItem, option, $event)"
                styleClass="w-full"></p-checkbox>
              <label
                for="{{ formTemplateItem.name + (tabIndex ?? '') + '_' + option.value }}"
                class="mx-2 cursor-pointer">
                {{ option.label }}
              </label>
            </div>
          }
        }
      }
    }
  </ng-container>
</ng-template>

<ng-template
  #dynamicFieldValidations
  let-formTemplate="formTemplate"
  let-parentGroup="parentGroup"
  let-tabIndex="tabIndex">
  <ng-container [formGroup]="parentGroup">
    @switch (formTemplate.type) {
      @case (eDynamicFormType.InputText) {
        @if (getControlByName(parentGroup, formTemplate.name)?.touched) {
          <div>
            @if (getControlByName(parentGroup, formTemplate.name)?.hasError('required')) {
              <p-message
                styleClass="p-inline-message-validation"
                icon="pi pi-info-circle"
                text="{{ formTemplate.label }} {{ 'DynamicForm.IsRequired' | translate }}">
              </p-message>
            }
            @if (getControlByName(parentGroup, formTemplate.name)?.hasError('email')) {
              <p-message
                styleClass="p-inline-message-validation"
                icon="pi pi-info-circle"
                text="{{ formTemplate.label }} {{ 'DynamicForm.ShouldBeValid' | translate }}">
              </p-message>
            }
            @if (getControlByName(parentGroup, formTemplate.name)?.hasError('pattern')) {
              <p-message
                styleClass="p-inline-message-validation"
                icon="pi pi-info-circle"
                text="{{ formTemplate.label }} {{ 'DynamicForm.ShouldBeValidPattern' | translate }}">
              </p-message>
            }
            @if (getControlByName(parentGroup, formTemplate.name)?.hasError('minlength')) {
              <p-message
                styleClass="p-inline-message-validation"
                icon="pi pi-info-circle"
                text="{{ formTemplate.label }} {{ 'DynamicForm.ShouldNotBeLessThan' | translate }} {{
                  getRestrictionValue(formTemplate, eRestriction.MinLength)
                }} {{ 'DynamicForm.Characters' | translate }}">
              </p-message>
            }
            @if (getControlByName(parentGroup, formTemplate.name)?.hasError('maxlength')) {
              <p-message
                styleClass="p-inline-message-validation"
                icon="pi pi-info-circle"
                text="{{ formTemplate.label }} {{ 'DynamicForm.ShouldNotBeMoreThan' | translate }} {{
                  getRestrictionValue(formTemplate, eRestriction.MaxLength)
                }} {{ 'DynamicForm.Characters' | translate }}">
              </p-message>
            }
          </div>
        }
      }

      @case (eDynamicFormType.InputNumber) {
        @if (
          formTemplate.warnings &&
          getControlByName(parentGroup, formTemplate.name)?.value >= formTemplate.warnings.min &&
          getControlByName(parentGroup, formTemplate.name)?.value <= formTemplate.warnings.max
        ) {
          <p-message icon="pi pi-info-circle" text="{{ 'DynamicForm.WarningMessageRHD' | translate }} "> </p-message>
        }
        @if (
          getControlByName(parentGroup, formTemplate.name)?.dirty ||
          getControlByName(parentGroup, formTemplate.name)?.touched
        ) {
          <div>
            @if (getControlByName(parentGroup, formTemplate.name)?.hasError('required')) {
              <p-message
                styleClass="p-inline-message-validation"
                icon="pi pi-info-circle"
                text="{{ formTemplate.label }} {{ 'DynamicForm.IsRequired' | translate }}">
              </p-message>
            }
            @if (getControlByName(parentGroup, formTemplate.name)?.hasError('min')) {
              <p-message
                styleClass="p-inline-message-validation"
                icon="pi pi-info-circle"
                text="{{ formTemplate.label }} {{ 'DynamicForm.ShouldNotBeLessThan' | translate }} {{
                  getRestrictionValue(formTemplate, eRestriction.Min)
                }}">
              </p-message>
            }
            @if (getControlByName(parentGroup, formTemplate.name)?.hasError('max')) {
              <p-message
                styleClass="p-inline-message-validation"
                icon="pi pi-info-circle"
                text="{{ formTemplate.label }} {{ 'DynamicForm.ShouldNotBeMoreThan' | translate }} {{
                  getRestrictionValue(formTemplate, eRestriction.Max)
                }}">
              </p-message>
            }
          </div>
        }
      }

      @case (eDynamicFormType.Textarea) {
        @if (getControlByName(parentGroup, formTemplate.name)?.touched) {
          <div>
            @if (getControlByName(parentGroup, formTemplate.name)?.hasError('required')) {
              <p-message
                styleClass="p-inline-message-validation"
                icon="pi pi-info-circle"
                text="{{ formTemplate.label }} {{ 'DynamicForm.IsRequired' | translate }}">
              </p-message>
            }
            @if (getControlByName(parentGroup, formTemplate.name)?.hasError('minlength')) {
              <p-message
                styleClass="p-inline-message-validation"
                icon="pi pi-info-circle"
                text="{{ formTemplate.label }} {{ 'DynamicForm.ShouldNotBeLessThan' | translate }} {{
                  getRestrictionValue(formTemplate, eRestriction.MinLength)
                }} {{ 'DynamicForm.Characters' | translate }}">
              </p-message>
            }
            @if (getControlByName(parentGroup, formTemplate.name)?.hasError('maxlength')) {
              <p-message
                styleClass="p-inline-message-validation"
                icon="pi pi-info-circle"
                text="{{ formTemplate.label }} {{ 'DynamicForm.ShouldNotBeMoreThan' | translate }} {{
                  getRestrictionValue(formTemplate, eRestriction.MaxLength)
                }} {{ 'DynamicForm.Characters' | translate }}">
              </p-message>
            }
          </div>
        }
      }

      @case (eDynamicFormType.Date) {
        @if (getControlByName(parentGroup, formTemplate.name)?.touched) {
          <div>
            @if (getControlByName(parentGroup, formTemplate.name)?.hasError('required')) {
              <p-message
                styleClass="p-inline-message-validation"
                icon="pi pi-info-circle"
                text="{{ formTemplate.label }} {{ 'DynamicForm.IsRequired' | translate }}">
              </p-message>
            }
            @if (getControlByName(parentGroup, formTemplate.name)?.hasError('mindate')) {
              <p-message
                styleClass="p-inline-message-validation"
                icon="pi pi-info-circle"
                text="{{ formTemplate.label }} {{ 'DynamicForm.ShouldNotBeLessThan' | translate }} {{
                  getRestrictionValue(formTemplate, eRestriction.MinDate) | date: formTemplate.format
                }}">
              </p-message>
            }
            @if (getControlByName(parentGroup, formTemplate.name)?.hasError('maxdate')) {
              <p-message
                styleClass="p-inline-message-validation"
                icon="pi pi-info-circle"
                text="{{ formTemplate.label }} {{ 'DynamicForm.ShouldNotBeMoreThan' | translate }} {{
                  getRestrictionValue(formTemplate, eRestriction.MaxDate) | date: formTemplate.format
                }}">
              </p-message>
            }
          </div>
        }
      }

      @case (eDynamicFormType.Select) {
        @if (getControlByName(parentGroup, formTemplate.name)?.touched) {
          <div>
            @if (getControlByName(parentGroup, formTemplate.name)?.hasError('required')) {
              <p-message
                styleClass="p-inline-message-validation"
                icon="pi pi-info-circle"
                text="{{ formTemplate.label }} {{ 'DynamicForm.IsRequired' | translate }}">
              </p-message>
            }
            @if (getControlByName(parentGroup, formTemplate.name)?.hasError('bloodGroup')) {
              <p-message
                styleClass="p-inline-message-validation"
                icon="pi pi-info-circle"
                text="{{ 'DynamicForm.bloodGroupRestrictions' | translate }} ">
              </p-message>
            }
            @if (getControlByName(parentGroup, formTemplate.name)?.hasError('numberOfFetusesMulti')) {
              <p-message
                styleClass="p-inline-message-validation"
                icon="pi pi-info-circle"
                text="{{ 'DynamicForm.RHDPregnancyRestrictions' | translate }} ">
              </p-message>
            }
          </div>
        }
      }

      @case (eDynamicFormType.MultiSelect) {
        @if (getControlByName(parentGroup, formTemplate.name)?.touched) {
          <div>
            @if (getControlByName(parentGroup, formTemplate.name)?.hasError('required')) {
              <p-message
                styleClass="p-inline-message-validation"
                icon="pi pi-info-circle"
                text="{{ formTemplate.label }} {{ 'DynamicForm.IsRequired' | translate }}">
              </p-message>
            }
          </div>
        }
      }

      @case (eDynamicFormType.RadioButton) {
        @if (getControlByName(parentGroup, formTemplate.name)?.touched) {
          <div>
            @if (getControlByName(parentGroup, formTemplate.name)?.hasError('required')) {
              <p-message
                styleClass="p-inline-message-validation"
                icon="pi pi-info-circle"
                text="{{ formTemplate.label }} {{ 'DynamicForm.IsRequired' | translate }}">
              </p-message>
            }
          </div>
        }
      }

      @case (eDynamicFormType.Checkbox) {
        @if (getControlByName(parentGroup, formTemplate.name)?.touched) {
          <div>
            @if (getControlByName(parentGroup, formTemplate.name)?.hasError('required')) {
              <p-message
                styleClass="p-inline-message-validation"
                icon="pi pi-info-circle"
                text="{{ formTemplate.label }} {{ 'DynamicForm.IsRequired' | translate }}">
              </p-message>
            }
          </div>
        }
      }
    }
  </ng-container>
</ng-template>
